import { format as fmtDate, parseISO } from "date-fns";

const EUR_LARGE = new Intl.NumberFormat("en-IE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 0,
});
const EUR_SMALL = new Intl.NumberFormat("en-IE", {
  style: "currency",
  currency: "EUR",
  maximumFractionDigits: 2,
});

export function eur(v?: number | null, opts?: { short?: boolean }): string {
  if (v == null || Number.isNaN(v)) return "—";
  if (opts?.short && Math.abs(v) >= 1_000_000)
    return `€${(v / 1_000_000).toFixed(v % 1_000_000 === 0 ? 0 : 1)}M`;
  if (opts?.short && Math.abs(v) >= 1_000) return `€${Math.round(v / 1000)}k`;
  return Math.abs(v) >= 100 ? EUR_LARGE.format(v) : EUR_SMALL.format(v);
}

export function pct(v?: number | null): string {
  if (v == null) return "—";
  return `${Math.round(v * 100)}%`;
}

export function fmtDay(d?: string | null, pattern = "d MMM yyyy"): string {
  if (!d) return "—";
  try {
    return fmtDate(parseISO(d), pattern);
  } catch {
    return d;
  }
}

export function fmtDayShort(d?: string | null): string {
  return fmtDay(d, "d MMM");
}

export function relativeDays(days?: number | null): string {
  if (days == null) return "—";
  if (days === 0) return "today";
  if (days === 1) return "1 day";
  return `${days} days`;
}
